module.exports = __webpack_public_path__ + "img/violet_094.605c83b9.png";